export default __webpack_public_path__ + "static/media/__apple_icon_text.4a167f5d.svg";